export const TOKEN_KEY = 'admin_token_key'
export const AUTH_KEY = 'admin_auth_key'
export const REF_CODE = 'admin_ref_code'
